import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const TemplatesStep = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g filter="url(#filter0_bd_7761_471677)">
          <mask id="path-1-inside-1_7761_471677" fill="white">
            <path d="M3.2002 5.2002C3.2002 4.09563 4.09563 3.2002 5.2002 3.2002H13.2002C14.3048 3.2002 15.2002 4.09563 15.2002 5.2002V13.2002C15.2002 14.3048 14.3048 15.2002 13.2002 15.2002H5.2002C4.09563 15.2002 3.2002 14.3048 3.2002 13.2002V5.2002Z" />
          </mask>
          <path
            d="M3.2002 5.2002C3.2002 4.09563 4.09563 3.2002 5.2002 3.2002H13.2002C14.3048 3.2002 15.2002 4.09563 15.2002 5.2002V13.2002C15.2002 14.3048 14.3048 15.2002 13.2002 15.2002H5.2002C4.09563 15.2002 3.2002 14.3048 3.2002 13.2002V5.2002Z"
            fill="#04AF00"
          />
          <path
            d="M5.2002 4.7002H13.2002V1.7002H5.2002V4.7002ZM13.7002 5.2002V13.2002H16.7002V5.2002H13.7002ZM13.2002 13.7002H5.2002V16.7002H13.2002V13.7002ZM4.7002 13.2002V5.2002H1.7002V13.2002H4.7002ZM5.2002 13.7002C4.92405 13.7002 4.7002 13.4763 4.7002 13.2002H1.7002C1.7002 15.1332 3.2672 16.7002 5.2002 16.7002V13.7002ZM13.7002 13.2002C13.7002 13.4763 13.4763 13.7002 13.2002 13.7002V16.7002C15.1332 16.7002 16.7002 15.1332 16.7002 13.2002H13.7002ZM13.2002 4.7002C13.4763 4.7002 13.7002 4.92405 13.7002 5.2002H16.7002C16.7002 3.2672 15.1332 1.7002 13.2002 1.7002V4.7002ZM5.2002 1.7002C3.2672 1.7002 1.7002 3.2672 1.7002 5.2002H4.7002C4.7002 4.92405 4.92405 4.7002 5.2002 4.7002V1.7002Z"
            fill="white"
            mask="url(#path-1-inside-1_7761_471677)"
          />
        </g>
        <g filter="url(#filter1_bd_7761_471677)">
          <mask id="path-3-inside-2_7761_471677" fill="white">
            <path d="M3.2002 18.7998C3.2002 17.6952 4.09563 16.7998 5.2002 16.7998H13.2002C14.3048 16.7998 15.2002 17.6952 15.2002 18.7998V26.7998C15.2002 27.9044 14.3048 28.7998 13.2002 28.7998H5.2002C4.09563 28.7998 3.2002 27.9044 3.2002 26.7998V18.7998Z" />
          </mask>
          <path
            d="M3.2002 18.7998C3.2002 17.6952 4.09563 16.7998 5.2002 16.7998H13.2002C14.3048 16.7998 15.2002 17.6952 15.2002 18.7998V26.7998C15.2002 27.9044 14.3048 28.7998 13.2002 28.7998H5.2002C4.09563 28.7998 3.2002 27.9044 3.2002 26.7998V18.7998Z"
            fill="#EC1E28"
          />
          <path
            d="M5.2002 18.2998H13.2002V15.2998H5.2002V18.2998ZM13.7002 18.7998V26.7998H16.7002V18.7998H13.7002ZM13.2002 27.2998H5.2002V30.2998H13.2002V27.2998ZM4.7002 26.7998V18.7998H1.7002V26.7998H4.7002ZM5.2002 27.2998C4.92405 27.2998 4.7002 27.0759 4.7002 26.7998H1.7002C1.7002 28.7328 3.2672 30.2998 5.2002 30.2998V27.2998ZM13.7002 26.7998C13.7002 27.0759 13.4763 27.2998 13.2002 27.2998V30.2998C15.1332 30.2998 16.7002 28.7328 16.7002 26.7998H13.7002ZM13.2002 18.2998C13.4763 18.2998 13.7002 18.5237 13.7002 18.7998H16.7002C16.7002 16.8668 15.1332 15.2998 13.2002 15.2998V18.2998ZM5.2002 15.2998C3.2672 15.2998 1.7002 16.8668 1.7002 18.7998H4.7002C4.7002 18.5237 4.92405 18.2998 5.2002 18.2998V15.2998Z"
            fill="white"
            mask="url(#path-3-inside-2_7761_471677)"
          />
        </g>
        <g filter="url(#filter2_bd_7761_471677)">
          <mask id="path-5-inside-3_7761_471677" fill="white">
            <path d="M16.7998 5.2002C16.7998 4.09563 17.6952 3.2002 18.7998 3.2002H26.7998C27.9044 3.2002 28.7998 4.09563 28.7998 5.2002V13.2002C28.7998 14.3048 27.9044 15.2002 26.7998 15.2002H18.7998C17.6952 15.2002 16.7998 14.3048 16.7998 13.2002V5.2002Z" />
          </mask>
          <path
            d="M16.7998 5.2002C16.7998 4.09563 17.6952 3.2002 18.7998 3.2002H26.7998C27.9044 3.2002 28.7998 4.09563 28.7998 5.2002V13.2002C28.7998 14.3048 27.9044 15.2002 26.7998 15.2002H18.7998C17.6952 15.2002 16.7998 14.3048 16.7998 13.2002V5.2002Z"
            fill="#F3D73B"
          />
          <path
            d="M18.7998 4.7002H26.7998V1.7002H18.7998V4.7002ZM27.2998 5.2002V13.2002H30.2998V5.2002H27.2998ZM26.7998 13.7002H18.7998V16.7002H26.7998V13.7002ZM18.2998 13.2002V5.2002H15.2998V13.2002H18.2998ZM18.7998 13.7002C18.5237 13.7002 18.2998 13.4763 18.2998 13.2002H15.2998C15.2998 15.1332 16.8668 16.7002 18.7998 16.7002V13.7002ZM27.2998 13.2002C27.2998 13.4763 27.0759 13.7002 26.7998 13.7002V16.7002C28.7328 16.7002 30.2998 15.1332 30.2998 13.2002H27.2998ZM26.7998 4.7002C27.0759 4.7002 27.2998 4.92405 27.2998 5.2002H30.2998C30.2998 3.2672 28.7328 1.7002 26.7998 1.7002V4.7002ZM18.7998 1.7002C16.8668 1.7002 15.2998 3.2672 15.2998 5.2002H18.2998C18.2998 4.92405 18.5237 4.7002 18.7998 4.7002V1.7002Z"
            fill="white"
            mask="url(#path-5-inside-3_7761_471677)"
          />
        </g>
        <g filter="url(#filter3_bd_7761_471677)">
          <mask id="path-7-inside-4_7761_471677" fill="white">
            <path d="M16.7998 18.7998C16.7998 17.6952 17.6952 16.7998 18.7998 16.7998H26.7998C27.9044 16.7998 28.7998 17.6952 28.7998 18.7998V26.7998C28.7998 27.9044 27.9044 28.7998 26.7998 28.7998H18.7998C17.6952 28.7998 16.7998 27.9044 16.7998 26.7998V18.7998Z" />
          </mask>
          <path
            d="M16.7998 18.7998C16.7998 17.6952 17.6952 16.7998 18.7998 16.7998H26.7998C27.9044 16.7998 28.7998 17.6952 28.7998 18.7998V26.7998C28.7998 27.9044 27.9044 28.7998 26.7998 28.7998H18.7998C17.6952 28.7998 16.7998 27.9044 16.7998 26.7998V18.7998Z"
            fill="#2AB5F0"
          />
          <path
            d="M18.7998 18.2998H26.7998V15.2998H18.7998V18.2998ZM27.2998 18.7998V26.7998H30.2998V18.7998H27.2998ZM26.7998 27.2998H18.7998V30.2998H26.7998V27.2998ZM18.2998 26.7998V18.7998H15.2998V26.7998H18.2998ZM18.7998 27.2998C18.5237 27.2998 18.2998 27.0759 18.2998 26.7998H15.2998C15.2998 28.7328 16.8668 30.2998 18.7998 30.2998V27.2998ZM27.2998 26.7998C27.2998 27.0759 27.0759 27.2998 26.7998 27.2998V30.2998C28.7328 30.2998 30.2998 28.7328 30.2998 26.7998H27.2998ZM26.7998 18.2998C27.0759 18.2998 27.2998 18.5237 27.2998 18.7998H30.2998C30.2998 16.8668 28.7328 15.2998 26.7998 15.2998V18.2998ZM18.7998 15.2998C16.8668 15.2998 15.2998 16.8668 15.2998 18.7998H18.2998C18.2998 18.5237 18.5237 18.2998 18.7998 18.2998V15.2998Z"
            fill="white"
            mask="url(#path-7-inside-4_7761_471677)"
          />
        </g>
        <defs>
          <filter
            id="filter0_bd_7761_471677"
            x="-1.99211"
            y="-1.99211"
            width="22.3846"
            height="22.3846"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.59615" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_7761_471677" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
            <feBlend mode="normal" in2="effect1_backgroundBlur_7761_471677" result="effect2_dropShadow_7761_471677" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_7761_471677" result="shape" />
          </filter>
          <filter
            id="filter1_bd_7761_471677"
            x="-1.99211"
            y="11.6075"
            width="22.3846"
            height="22.3846"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.59615" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_7761_471677" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
            <feBlend mode="normal" in2="effect1_backgroundBlur_7761_471677" result="effect2_dropShadow_7761_471677" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_7761_471677" result="shape" />
          </filter>
          <filter
            id="filter2_bd_7761_471677"
            x="11.6075"
            y="-1.99211"
            width="22.3846"
            height="22.3846"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.59615" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_7761_471677" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
            <feBlend mode="normal" in2="effect1_backgroundBlur_7761_471677" result="effect2_dropShadow_7761_471677" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_7761_471677" result="shape" />
          </filter>
          <filter
            id="filter3_bd_7761_471677"
            x="11.6075"
            y="11.6075"
            width="22.3846"
            height="22.3846"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.59615" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_7761_471677" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
            <feBlend mode="normal" in2="effect1_backgroundBlur_7761_471677" result="effect2_dropShadow_7761_471677" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_7761_471677" result="shape" />
          </filter>
        </defs>
      </svg>
    )
  },
)

export default TemplatesStep
